/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as React from 'react'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Chip from '@material-ui/core/Chip'
import Checkbox from '@material-ui/core/Checkbox'
import ListItemText from '@material-ui/core/ListItemText'
import { IControlProps } from './types'
import { ITag } from '../../models/Franchise'

export interface ITagControlProps extends IControlProps {
  tagOptions: ITag[]
}

export class TagControl extends React.Component<ITagControlProps> {
  constructor(props: ITagControlProps) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const tagIds: number[] = event.target.value
    const selectedTags = tagIds.map(
      (tagId) => this.props.tagOptions.find((tag) => tag.id == tagId)!
    )
    this.props.form.setFieldValue(this.props.field.name, selectedTags)
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const value: ITag[] = this.props.field.value || []
    // tags may have been disabled, they are not avaiable in the tagOptions
    // so we need to add them back to the list
    const legacyTags: ITag[] = value.filter((tag: ITag) => {
      return !this.props.tagOptions.find((t: ITag) => t.id == tag.id)
    })
    const allTags = this.props.tagOptions.concat(legacyTags)
    const selectedTagIds = value.map((tag) => tag.id)
    return (
      <Select
        multiple
        id={this.props.id}
        value={selectedTagIds}
        onChange={this.handleChange}
        renderValue={(selected: any) => (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access*/}
            {selected.map((tagId: number) => (
              <Chip
                key={tagId}
                label={allTags.find((tag) => tag.id == tagId)!.name}
                style={{ margin: 4 }}
              />
            ))}
          </div>
        )}
      >
        {allTags.map((tag) => (
          <MenuItem key={tag.name} value={tag.id} disabled={tag.mandatory}>
            <Checkbox
              checked={selectedTagIds.includes(tag.id)}
              disabled={tag.mandatory}
            />
            <ListItemText primary={tag.name} />
          </MenuItem>
        ))}
      </Select>
    )
  }
}
